// Root UI renderer file
<template>
  <loader id="loader" class="hidden"></loader>
  <Header />
  <router-view />
  <Footer />
</template>

<script>
import Header from "./components/Layout/Header.vue";
import Footer from "./components/Layout/Footer.vue";
import Loader from "./components/Layout/Form/Loader.vue";
export default {
  name: "App",
  components: {
    Header,
    Footer,
    Loader
  },
  data() {
    return {
    };
  },
  mounted() {
    let agentTkn = JSON.parse(localStorage.getItem("agent_data"));
    let selectedAgent = JSON.parse(localStorage.getItem("selected_agent"));
    let regisData = JSON.parse(localStorage.getItem("registered_user"));

    if (
      agentTkn != undefined &&
      agentTkn != "" &&
      agentTkn != null &&
      agentTkn != []
    ) {
        this.$store.dispatch("setAgentTkn");
        if (
        selectedAgent != undefined &&
        selectedAgent != "" &&
        selectedAgent != null &&
        selectedAgent != []
      ) {
        this.$store.dispatch("setSelectedAgent");
      }
      this.$store.dispatch("getAgentData").then((result1) => {
          console.log(result1);
        }).catch((error) => {
          this.$toast.error(error.message);
          this.$store.dispatch("logout");
          this.$router.push("/login");
        });
    }
    if (
      regisData != undefined &&
      regisData != "" &&
      regisData != null &&
      regisData != []
    ) {
      this.$store.dispatch("setRegData");
    }
  }
};
</script>
